import { render, staticRenderFns } from "./SipPanel.vue?vue&type=template&id=9c763a8c&scoped=true"
import script from "./SipPanel.vue?vue&type=script&lang=js"
export * from "./SipPanel.vue?vue&type=script&lang=js"
import style0 from "./SipPanel.vue?vue&type=style&index=0&id=9c763a8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c763a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c763a8c')) {
      api.createRecord('9c763a8c', component.options)
    } else {
      api.reload('9c763a8c', component.options)
    }
    module.hot.accept("./SipPanel.vue?vue&type=template&id=9c763a8c&scoped=true", function () {
      api.rerender('9c763a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/SipPanel.vue"
export default component.exports